import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FileResponse, FilesClient } from '@medone/medonehp-api-client';

import { AppDispatch, AppThunk, RootState } from '../../store';
import { Axios } from '../http';
import { FileState, initialState } from './models';

export const filesSlice = createSlice({
    name: 'files',
    initialState,
    reducers: {
        setError: (state: FileState, action: PayloadAction<any>) => {
            state.error = action.payload;
        },
    },
});

export function downloadFile(filePath: string): AppThunk<Promise<FileResponse>> {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        const client = new FilesClient(null, Axios);

        try {
            const response = await client.download(filePath);

            return response.result;
        } catch (error) {}

        return null;
    };
}

export const selectFilesError = (state: RootState) => state.files.error;

export default filesSlice.reducer;
